module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-zip-ad8ec575931b3f6811f87e0c2df8d77f.svg";